var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CalendarResourceService } from '@/service/CalendarResourceService';
import { reactive } from 'vue';
const AppState = reactive({
    locationId: '',
    eventId: '',
    location: '',
    timezone: 'UTC',
    isTimezoneConfigEnabled: false,
    locale: '',
    receivedData: {},
    viewActivityLog: false,
    viewAdditionalDetails: false,
    viewUserInfo: false,
    showEditAppointmentModal: false,
    editAppointmentData: {},
    appointmentDetail: undefined,
    calendarDetail: undefined,
    contactDetails: undefined,
    userDetails: undefined,
    appointmentOwnerDetails: undefined,
    guestsDetails: [],
    appointmentsRef: [],
    loggedInUserId: '',
    globalRooms: [],
    globalEquipments: [],
});
export const setInitialValues = (data) => {
    var _a;
    AppState.eventId = data.eventId;
    AppState.location = data.location;
    AppState.timezone = data.timeZone;
    AppState.isTimezoneConfigEnabled = data.isTimezoneConfigEnabled;
    AppState.receivedData = data;
    AppState.loggedInUserId = (_a = data === null || data === void 0 ? void 0 : data.userId) !== null && _a !== void 0 ? _a : '';
};
export const resetAppState = () => {
    AppState.locationId = '';
    AppState.eventId = '';
    AppState.location = '';
    AppState.timezone = 'UTC';
    AppState.locale = '';
    AppState.receivedData = {};
    AppState.viewActivityLog = false;
    AppState.viewAdditionalDetails = false;
    AppState.viewUserInfo = false;
    AppState.showEditAppointmentModal = false;
    AppState.editAppointmentData = {};
    AppState.appointmentDetail = null;
    AppState.calendarDetail = null;
    AppState.contactDetails = null;
    AppState.userDetails = null;
    AppState.appointmentOwnerDetails = null;
    AppState.guestsDetails = [];
    AppState.appointmentsRef = [];
    AppState.loggedInUserId = '';
};
export const setEventId = (id) => {
    AppState.eventId = id;
};
export const setLocationId = (id) => {
    AppState.locationId = id;
};
export const setViewActivityLog = (value) => {
    AppState.viewActivityLog = value;
};
export const setViewAdditionalDetails = (value) => {
    AppState.viewAdditionalDetails = value;
};
export const openEditAppointmentModal = (eventType, eventId) => {
    const editAppointmentData = AppState.receivedData;
    const isBlockSlot = eventType === 'event';
    editAppointmentData.reschedule = 'All';
    editAppointmentData.isNewBlockSlot = isBlockSlot ? true : false;
    editAppointmentData.isNewEvent = isBlockSlot ? false : true;
    editAppointmentData.eventId = eventId !== null && eventId !== void 0 ? eventId : AppState.eventId;
    editAppointmentData.locationId = AppState.locationId;
    editAppointmentData.calendars = AppState.receivedData.calendars;
    editAppointmentData.groups = AppState.receivedData.groups;
    editAppointmentData.users = AppState.receivedData.users;
    if (editAppointmentData.appointmentIds) {
        editAppointmentData.appointmentIds = Array.from(editAppointmentData === null || editAppointmentData === void 0 ? void 0 : editAppointmentData.appointmentIds);
    }
    AppState.appointmentDetail = AppState.appointmentsRef.find((x) => x.id === editAppointmentData.eventId);
    AppState.editAppointmentData = editAppointmentData;
    AppState.showEditAppointmentModal = !AppState.showEditAppointmentModal;
};
export const getRoomsInLocation = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const locationId = AppState.locationId;
    if ((_a = AppState === null || AppState === void 0 ? void 0 : AppState.globalRooms) === null || _a === void 0 ? void 0 : _a.find(e => e.locationId === locationId)) {
        return AppState.globalRooms;
    }
    const res = yield CalendarResourceService.find(AppState.locationId, 'rooms');
    if (res === null || res === void 0 ? void 0 : res.length) {
        AppState.globalRooms = res;
    }
    else {
        AppState.globalRooms = [];
    }
    return AppState.globalRooms;
});
export const getEquipmentsInLocation = () => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const locationId = AppState.locationId;
    if ((_b = AppState === null || AppState === void 0 ? void 0 : AppState.globalEquipments) === null || _b === void 0 ? void 0 : _b.find(e => e.locationId === locationId)) {
        return AppState.globalEquipments;
    }
    const res = yield CalendarResourceService.find(AppState.locationId, 'equipments');
    if (res === null || res === void 0 ? void 0 : res.length) {
        AppState.globalEquipments = res;
    }
    else {
        AppState.globalEquipments = [];
    }
    return AppState.globalEquipments;
});
export const getLoggedInUserTimezone = () => {
    var _a;
    const loggedInUser = ((_a = AppState.receivedData) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) || {};
    const locationId = AppState.locationId;
    const locationWiseTimezone = (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.locationWiseTimezone) || {};
    return locationWiseTimezone[locationId] || AppState.timezone;
};
export const getTargetTimezone = () => {
    return AppState.isTimezoneConfigEnabled
        ? getLoggedInUserTimezone()
        : AppState.timezone; // location timezone
};
export default AppState;
